"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withTheme = _interopRequireDefault(require("./withTheme"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var _default = exports.default = (0, _withTheme.default)(() => /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "m 22.3228,18.360711 v 1.671957 c 0,1.264884 -1.025392,2.290276 -2.290276,2.290276 h -8.015963",
    id: "path6580",
    strokeWidth: "2",
    strokeMiterlimit: "4",
    strokeDasharray: "none"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M 12.016561,1.7104667 H 4.0005979 A 2.2902753,2.2902753 0 0 0 1.7103226,4.000742 v 16.031926 a 2.2902753,2.2902753 0 0 0 2.2902753,2.290276 h 8.0159631",
    id: "path6578",
    strokeWidth: "2",
    strokeMiterlimit: "4",
    strokeDasharray: "none"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M 12.016561,1.7104667 V 22.322944",
    id: "path6564",
    strokeWidth: "2",
    strokeMiterlimit: "4",
    strokeDasharray: "none"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "m 22.32197,5.4889697 0.0028,-1.481112 C 22.32706,2.7459311 21.301613,1.7216966 20.036155,1.7201661 l -8.019594,-0.0097",
    id: "path6580-8",
    strokeWidth: "2",
    strokeMiterlimit: "4",
    strokeDasharray: "none"
  }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
    id: "g7186",
    transform: "matrix(2.2330041,0,0,2.2330041,-21.058841,-14.498659)",
    strokeWidth: "0.89565444",
    strokeMiterlimit: "4",
    strokeDasharray: "none",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("line", {
      strokeWidth: "0.89565444",
      strokeMiterlimit: "4",
      strokeDasharray: "none",
      id: "line5914",
      y2: "13.397092",
      x2: "18.110062",
      y1: "10.306173",
      x1: "18.110062"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("line", {
      strokeWidth: "0.89565444",
      strokeMiterlimit: "4",
      strokeDasharray: "none",
      id: "line5916",
      y2: "11.851624",
      x2: "19.655523",
      y1: "11.851624",
      x1: "16.564611"
    })]
  })]
}));